import React, { useState, useEffect } from "react";
import { Modal, Form, notification, Upload, Row, Col, Input } from "antd";
import { EditOutlined } from "@ant-design/icons";
import Joi from "joi";
import _ from "lodash";
import http from "../../../../helpers/http";
import config from "../../../../config/config";
import helper from "../../../../helpers/helper";

function Edit({
  isVisible,
  handleClose,
  dbData,
  moduleName,
  image_url,
  base_url,
}) {
  const [form] = Form.useForm();
  const [loading, setloading] = useState(false);
  const [formError, setFormError] = useState({});

  const sizeLimit = config.sizeLimit;

  const allowedExtensions = config.allowed_extensions;
  const joiOptions = config.joiOptions;

  const validate = (value) => {
    let schemaObj = {
      // image: Joi.required(),
    };

    const schema = Joi.object(schemaObj).options({ allowUnknown: true });

    const { error } = schema.validate(value, joiOptions);

    const errors = {};

    if (error) {
      error.details.map((field) => {
        errors[field.path[0]] = field.message;
        return true;
      });
    }

    helper.validateSize("image", value.image, sizeLimit, errors);
    helper.validateExt("image", value.image, allowedExtensions, errors);
    helper.validateSize("mobile_image", value.mobile_image, sizeLimit, errors);
    helper.validateExt(
      "mobile_image",
      value.mobile_image,
      allowedExtensions,
      errors
    );

    return errors ? errors : null;
  };

  const handleSubmit = async (value) => {
    let errors = validate(value);
    setFormError(errors);

    if (Object.keys(errors).length) {
      return;
    }

    setloading(true);
    let formData = new FormData();

    for (const [key, data] of Object.entries(
      _.omit(value, ["image", "mobile_image"])
    )) {
      formData.append(key, data || "");
    }
    if (value.image) {
      formData.append("image", value.image.file);
    }
    if (value.mobile_image) {
      formData.append("mobile_image", value.mobile_image.file);
    }

    const { data } = await http.put(`${base_url}/${dbData._id}`, formData);

    if (data) {
      notification["success"]({
        message: `${moduleName} Updated Successfully`,
      });
      setloading(false);
      form.resetFields();
      handleClose();
    }
  };

  useEffect(() => {
    form.setFieldsValue(_.omit(dbData, ["image", "mobile_image"]));
  }, [dbData]);

  return (
    <Modal
      title={`Edit ${moduleName}`}
      visible={isVisible}
      onCancel={handleClose}
      okText="Update"
      cancelText="Cancel"
      confirmLoading={loading}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            handleSubmit(values);
          })
          .catch((info) => {});
      }}
      width={700}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              required
              label="Image: (2560 X 1306)"
              name="image"
              {...(formError.image && {
                help: formError.image,
                validateStatus: "error",
              })}
            >
              <Upload
                beforeUpload={(file) => {
                  const allowedTypes = [
                    "image/jpeg",
                    "image/png",
                    "image/jpg",
                    "image/webp",
                  ];

                  if (!allowedTypes.includes(file.type)) {
                    notification.error({
                      message: "Invalid file type",
                      description:
                        "Only JPG, JPEG, PNG, WEBP files are allowed.",
                    });
                    return Upload.LIST_IGNORE;
                  }

                  return false;
                }}
                maxCount={1}
                listType="picture-card"
                showUploadList={{
                  showPreviewIcon: false,
                  showRemoveIcon: false,
                }}
                defaultFileList={[
                  {
                    thumbUrl: dbData.image
                      ? image_url + dbData.image
                      : "https://via.placeholder.com/100",
                  },
                ]}
              >
                <EditOutlined />
              </Upload>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              required
              label="Mobile Image: (640 X 630)"
              name="mobile_image"
              {...(formError.mobile_image && {
                help: formError.mobile_image,
                validateStatus: "error",
              })}
            >
              <Upload
                beforeUpload={(file) => {
                  const allowedTypes = [
                    "image/jpeg",
                    "image/png",
                    "image/jpg",
                    "image/webp",
                  ];

                  if (!allowedTypes.includes(file.type)) {
                    notification.error({
                      message: "Invalid file type",
                      description:
                        "Only JPG, JPEG, PNG, WEBP files are allowed.",
                    });
                    return Upload.LIST_IGNORE;
                  }

                  return false;
                }}
                maxCount={1}
                listType="picture-card"
                showUploadList={{
                  showPreviewIcon: false,
                  showRemoveIcon: false,
                }}
                defaultFileList={[
                  {
                    thumbUrl: dbData.mobile_image
                      ? image_url + dbData.mobile_image
                      : "https://via.placeholder.com/100",
                  },
                ]}
              >
                <EditOutlined />
              </Upload>
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item
              label="Title:"
              name="title"
              extra={
                <p>
                  ( Use <b>&lt;br&gt;</b> for line breaks )
                </p>
              }
              {...(formError.title && {
                help: formError.title,
                validateStatus: "error",
              })}
            >
              <Input />
            </Form.Item>
          </Col>
          {/* <Col xs={24} md={12}>
            <Form.Item
              
              label="Button Name:"
              name="btn_name"
              {...(formError.btn_name && {
                help: formError.btn_name,
                validateStatus: "error",
              })}
            >
             <Input />
            </Form.Item>
          </Col> */}
          <Col xs={24} md={12}>
            <Form.Item
              label="Banner URL:"
              name="btn_url"
              extra="Use an internal page URL (e.g., /about) for website pages, or a full URL for external websites (e.g., https://www.laxmihos.com). "
              {...(formError.btn_url && {
                help: formError.btn_url,
                validateStatus: "error",
              })}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default Edit;
